import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';

@Component({
  selector: 'app-card-bolsa',
  imports: [CommonModule, AvatarModule, AvatarGroupModule],
  templateUrl: './card-bolsa.component.html',
  styleUrls: ['./card-bolsa.component.scss'],
  standalone: true,
})
export class CardBolsaComponent {
  @Input() name: string = 'Bolsa de Mérito Académico para Mulheres';
  @Input() avatar: string = 'icons/certificate-blue.svg';
  @Input() estado: string = 'Activo';
  @Input() age: number = 30;
  @Input() country: string = 'Angola';
  @Input() duration: string = '6 meses';
  @Input() tipoBolsa: string = 'Integral';

  sponsor: string = 'Catoca';
  vacancies: number = 30;
  status: string = 'Activa';
  description: string =
    'Uma oportunidade para estudantes de alto desempenho ingressarem na graduação com cobertura integral das mensalidades. Destinada a alunos que concluíram o ensino médio com média igual ou superior a 17 valores.';
  startDate: string = '13/01/2025';
  endDate: string = '25/05/2025';
  extraParticipants: number = 5;
}
